import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import {cardsAndPromotionsFactory} from './cards-and-promotions.factory.js';

import PALETTE_SCHEMA from './cards-and-promotions.palette-schema.yaml';

class CardsAndBannersFeature extends AbstractVisualFeature {
    get name() {
        return 'CardsAndBanners';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(cardsAndPromotionsFactory(PALETTE), {
            InplayFallbackEventCard: {
                title: '$EVENT_CARDS.FALLBACK.INPLAY.TITLE',
                content: '$EVENT_CARDS.FALLBACK.INPLAY.CONTENT',
            },
            EventCardsCarousel: {
                fallbackSportId: GENBET_BASED ? 'soccer' : 'tennis',
            },
        });
    }
}

export const CardsAndPromotions = new CardsAndBannersFeature(allVisuals);
